var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtGithubVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 0C16.3411 0 0 16.3666 0 36.562C0 52.7133 10.4572 66.419 24.9623 71.2516C26.7873 71.5874 27.4517 70.4596 27.4517 69.4887C27.4517 68.6236 27.4225 66.3205 27.4042 63.2727C17.2499 65.481 15.1074 58.3708 15.1074 58.3708C13.4502 54.1441 11.0559 53.0199 11.0559 53.0199C7.74165 50.7569 11.3077 50.8007 11.3077 50.8007C14.9687 51.0562 16.8959 54.5675 16.8959 54.5675C20.1517 60.152 25.4405 58.5387 27.5173 57.6043C27.8531 55.2427 28.7949 53.6331 29.8388 52.7206C21.7358 51.7971 13.213 48.6581 13.213 34.6494C13.213 30.66 14.6365 27.3932 16.9689 24.8382C16.5929 23.9148 15.341 20.1954 17.3266 15.1658C17.3266 15.1658 20.3925 14.1803 27.364 18.9107C30.3416 18.0986 33.4137 17.685 36.5 17.6806C39.6025 17.6952 42.7233 18.1003 45.6396 18.9107C52.6074 14.1803 55.6661 15.1621 55.6661 15.1621C57.659 20.1954 56.4035 23.9148 56.0312 24.8382C58.3671 27.3932 59.7834 30.66 59.7834 34.6494C59.7834 48.6946 51.246 51.7862 43.1175 52.6914C44.4278 53.8193 45.5922 56.0494 45.5922 59.4622C45.5922 64.3458 45.5484 68.2915 45.5484 69.4887C45.5484 70.4669 46.2053 71.6057 48.0596 71.248C55.3278 68.8102 61.6461 64.1499 66.1215 57.9257C70.5969 51.7015 73.0031 44.2282 73 36.562C73 16.3666 56.6553 0 36.5 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtGithubVector);
export default __webpack_public_path__ + "static/media/at_github_vector.95080739b46e19723ddd1c865090ab55.svg";
export { ForwardRef as ReactComponent };